import React from 'react';

const JobTitleFilterIcon = (props: any) => {
  return (
    <svg height="20" width="20" fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5.0625 8.96777V14.7059C5.0625 14.7059 6.10766 17.0968 10.2883 17.0968C14.469 17.0968 15.5141 14.7059 15.5141 14.7059V8.96777"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M10.2903 2L1.89443 6.19795C1.5259 6.38221 1.5259 6.90811 1.89443 7.09237L10.2903 11.2903L18.1728 7.08634C18.5257 6.8981 18.5257 6.39222 18.1728 6.20398L10.2903 2Z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path d="M2.16406 7.8064V13.0322" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
    </svg>
  );
};

export default JobTitleFilterIcon;
